export enum MarketIntelTabId {
  General = 'general',
  SimulationTool = 'simulation-tool',
  Staff = 'staff',
  AlertsAndFlags = 'alerts-and-flags',
}
